export const CHATBOT_PARAMS_SYNC = 'chatbot-params-sync';

export type ChatbotParamsSyncDetail = {
  theme?: 'dark' | 'light';
  locale?: string;
};

export interface ChatbotEnv {
  baseUrl: string;
  navUrl: string;
  zendeskID: string;
  getToken: () => string | null | undefined;
  /** Help Center base URL，由各 app 从其 localized/config/site 注入 */
  helpCenterUrl: string;
  /** Chatbot WebSocket 基础域名（环境前缀由 baseUrl 自动派生），由各 app 注入 */
  wsBaseDomain: string;
  /** Chatbot SDK CDN fallback origin，当 navUrl 解析失败时使用，由各 app 注入 */
  cdnFallback: string;
  geetestCaptchaId?: string;
}

export interface ChatbotInitConfig {
  lang: string;
  theme: 'dark' | 'light';
  pageType: 'trade' | 'default';
  token: string;
  uid?: string;
  geetestCaptchaId: string;
  apiBaseUrl: string;
  wsBaseUrl: string;
  helpCenterBaseUrl: string;
  cfIpCountry: string;
}

export interface ChatbotGrayGateProps {
  theme: 'dark' | 'light';
  env: ChatbotEnv;
  isKrSite?: boolean;
  pageType?: 'trade' | 'default';
  /** Zendesk 加载后立即隐藏，仅通过 zE('messenger','show') 手动打开。交易页面（spot/futures）需设为 true。 */
  hideZendesk?: boolean;
  /**
   * 是否为子账户。应从上层 Redux userInfo 状态显式传入，避免依赖首屏 Cookie 快照。
   * - undefined：账号信息尚未加载；若同时 env.getToken() 为空（未登录页），
   *   Gate 内部会按主账户继续分流，不会死等。
   * - true：子账户，直接走 Zendesk
   * - false：主账户，走灰度分流
   */
  isSubAccount?: boolean;
}
